import React, { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

/**
 * v48 (AML-11): /verify-email landing.
 *
 * Email-верификация технически работает через api-gateway: пользователь кликает
 * на ссылку в письме → GET /email/verify?token=X (api-gateway) → отдаёт HTML.
 * Canonical baseURL `https://api.test.gsmsoft.eu/email/verify` (см. RFC-004 v43).
 *
 * Этот роут — safety-net на случай, если письмо ушло со старым `EMAIL_VERIFICATION_BASE_URL`,
 * указывающим на admin-panel (`admin.test.gsmsoft.eu/verify-email`). Раньше тут
 * был 404 nginx (см. AML-11 в v47 бэклоге). Теперь — редирект на api-gateway.
 *
 * Логика:
 *   1. Читаем ?token=X из URL.
 *   2. Делаем window.location.replace на api-gateway endpoint.
 *   3. Если REACT_APP_API_URL / window.API_URL не выставлен — показываем
 *      сообщение «обратитесь в поддержку».
 */

function resolveApiBase(): string {
  const w = window as any;
  // window.API_URL — runtime config (см. admin_panel/public/index.html)
  if (w?.API_URL) return String(w.API_URL).replace(/\/+$/, '');
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL.replace(/\/+$/, '');
  return '';
}

const VerifyEmailRedirect: React.FC = () => {
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('Параметр token отсутствует в ссылке. Скопируйте ссылку из письма полностью.');
      return;
    }
    const apiBase = resolveApiBase();
    if (!apiBase) {
      setError('API-адрес не настроен. Откройте ссылку из письма заново или обратитесь в поддержку.');
      return;
    }
    // api-gateway: GET /email/verify (canonical) и /verify-email (legacy alias)
    // оба обработаются handler'ом и вернут HTML success/error.
    const target = `${apiBase}/email/verify?token=${encodeURIComponent(token)}`;
    window.location.replace(target);
  }, [params]);

  return (
    <Card className="mx-auto mt-4" style={{ maxWidth: 520 }}>
      <Card.Body className="text-center py-5">
        <h4 className="mb-3">Подтверждение email</h4>
        {error ? (
          <div className="alert alert-warning small mb-0">{error}</div>
        ) : (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            <span className="text-muted">Перенаправление на сервер подтверждения…</span>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default VerifyEmailRedirect;
